import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import ReactDOM from 'react-dom';
import { ChevronDown, TrendingUp, TrendingDown } from 'lucide-react';

// РАСШИРЕННЫЙ список активов - бесплатные символы TradingView
const ASSETS = [
  // Основные валютные пары (FX)
  {
    symbol: 'EURUSD',
    name: 'EUR/USD',
    category: 'Основные валютные пары',
    price: '1.11460',
    change: '+0.0012',
    changePercent: '+0.11%',
    isPositive: true
  },
  {
    symbol: 'GBPUSD',
    name: 'GBP/USD', 
    category: 'Основные валютные пары',
    price: '1.29500',
    change: '+0.0025',
    changePercent: '+0.19%',
    isPositive: true
  },
  {
    symbol: 'USDJPY',
    name: 'USD/JPY',
    category: 'Основные валютные пары',
    price: '143.210',
    change: '+0.120',
    changePercent: '+0.08%',
    isPositive: true
  },
  {
    symbol: 'USDCHF',
    name: 'USD/CHF',
    category: 'Основные валютные пары',
    price: '0.86500',
    change: '-0.0015',
    changePercent: '-0.17%',
    isPositive: false
  },
  {
    symbol: 'AUDUSD',
    name: 'AUD/USD',
    category: 'Основные валютные пары',
    price: '0.67200',
    change: '+0.0018',
    changePercent: '+0.27%',
    isPositive: true
  },
  {
    symbol: 'USDCAD',
    name: 'USD/CAD',
    category: 'Основные валютные пары',
    price: '1.35800',
    change: '-0.0020',
    changePercent: '-0.15%',
    isPositive: false
  },
  {
    symbol: 'NZDUSD',
    name: 'NZD/USD',
    category: 'Основные валютные пары',
    price: '0.60200',
    change: '+0.0012',
    changePercent: '+0.20%',
    isPositive: true
  },

  // Минорные валютные пары
  {
    symbol: 'EURGBP',
    name: 'EUR/GBP',
    category: 'Минорные валютные пары',
    price: '0.83400',
    change: '-0.0008',
    changePercent: '-0.10%',
    isPositive: false
  },
  {
    symbol: 'EURJPY',
    name: 'EUR/JPY',
    category: 'Минорные валютные пары',
    price: '159.650',
    change: '+0.350',
    changePercent: '+0.22%',
    isPositive: true
  },
  {
    symbol: 'GBPJPY',
    name: 'GBP/JPY',
    category: 'Минорные валютные пары',
    price: '186.470',
    change: '+0.850',
    changePercent: '+0.46%',
    isPositive: true
  },
  {
    symbol: 'EURCHF',
    name: 'EUR/CHF',
    category: 'Минорные валютные пары',
    price: '0.96450',
    change: '+0.0025',
    changePercent: '+0.26%',
    isPositive: true
  },

  // Топовые криптовалюты (Binance)  
  {
    symbol: 'BTCUSD',
    name: 'Bitcoin',
    category: 'Криптовалюты',
    price: '67,500',
    change: '+1,250',
    changePercent: '+1.89%',
    isPositive: true
  },
  {
    symbol: 'ETHUSD',
    name: 'Ethereum',
    category: 'Криптовалюты', 
    price: '2,534',
    change: '+85',
    changePercent: '+3.47%',
    isPositive: true
  },
  {
    symbol: 'BNBUSD',
    name: 'BNB',
    category: 'Криптовалюты',
    price: '589.50',
    change: '+12.30',
    changePercent: '+2.13%',
    isPositive: true
  },
  {
    symbol: 'ADAUSD',
    name: 'Cardano',
    category: 'Криптовалюты',
    price: '0.3450',
    change: '+0.0120',
    changePercent: '+3.60%',
    isPositive: true
  },
  {
    symbol: 'SOLUSD',
    name: 'Solana',
    category: 'Криптовалюты',
    price: '145.20',
    change: '+8.75',
    changePercent: '+6.41%',
    isPositive: true
  },
  {
    symbol: 'XRPUSD',
    name: 'XRP',
    category: 'Криптовалюты',
    price: '0.5250',
    change: '+0.0180',
    changePercent: '+3.55%',
    isPositive: true
  },
  {
    symbol: 'DOTUSD',
    name: 'Polkadot',
    category: 'Криптовалюты',
    price: '4.15',
    change: '+0.18',
    changePercent: '+4.53%',
    isPositive: true
  },

  // Драгметаллы и товары (TVC)
  {
    symbol: 'XAUUSD',
    name: 'Золото',
    category: 'Драгметаллы и товары',
    price: '2,670.50',
    change: '+15.20',
    changePercent: '+0.57%',
    isPositive: true
  },
  {
    symbol: 'XAGUSD',
    name: 'Серебро',
    category: 'Драгметаллы и товары',
    price: '31.20',
    change: '+0.65',
    changePercent: '+2.12%',
    isPositive: true
  },
  {
    symbol: 'WTIUSD',
    name: 'Нефть WTI',
    category: 'Драгметаллы и товары',
    price: '75.85',
    change: '+1.15',
    changePercent: '+1.54%',
    isPositive: true
  },
  {
    symbol: 'XPDUSD',
    name: 'Палладий',
    category: 'Драгметаллы и товары',
    price: '1,025.50',
    change: '+18.25',
    changePercent: '+1.81%',
    isPositive: true
  },
  {
    symbol: 'XPTUSD',
    name: 'Платина',
    category: 'Драгметаллы и товары',
    price: '985.50',
    change: '+8.75',
    changePercent: '+0.90%',
    isPositive: true
  },

  // Топовые акции США (NASDAQ/NYSE)
  {
    symbol: 'AAPL',
    name: 'Apple Inc.',
    category: 'Топовые акции США',
    price: '227.50',
    change: '+2.85',
    changePercent: '+1.27%',
    isPositive: true
  },
  {
    symbol: 'MSFT',
    name: 'Microsoft Corp.',
    category: 'Топовые акции США',
    price: '415.85',
    change: '+3.15',
    changePercent: '+0.76%',
    isPositive: true
  },
  {
    symbol: 'GOOGL',
    name: 'Alphabet Inc.',
    category: 'Топовые акции США',
    price: '167.20',
    change: '+1.25',
    changePercent: '+0.75%',
    isPositive: true
  },
  {
    symbol: 'AMZN',
    name: 'Amazon.com',
    category: 'Топовые акции США',
    price: '178.25',
    change: '+2.10',
    changePercent: '+1.19%',
    isPositive: true
  },
  {
    symbol: 'TSLA',
    name: 'Tesla Inc.',
    category: 'Топовые акции США',
    price: '248.30',
    change: '-1.45',
    changePercent: '-0.58%',
    isPositive: false
  },
  {
    symbol: 'META',
    name: 'Meta Platforms',
    category: 'Топовые акции США',
    price: '568.75',
    change: '+8.45',
    changePercent: '+1.51%',
    isPositive: true
  },
  {
    symbol: 'NVDA',
    name: 'NVIDIA Corp.',
    category: 'Топовые акции США',
    price: '132.65',
    change: '+4.30',
    changePercent: '+3.35%',
    isPositive: true
  },
  {
    symbol: 'NFLX',
    name: 'Netflix Inc.',
    category: 'Топовые акции США',
    price: '701.35',
    change: '+12.80',
    changePercent: '+1.86%',
    isPositive: true
  },
  {
    symbol: 'CVX',
    name: 'Chevron Corp.',
    category: 'Топовые акции США',
    price: '154.13',
    change: '+1.25',
    changePercent: '+0.82%',
    isPositive: true
  },
  {
    symbol: 'KSPI',
    name: 'Kaspi.kz',
    category: 'Топовые акции США',
    price: '120.50',
    change: '+2.15',
    changePercent: '+1.82%',
    isPositive: true
  },
  {
    symbol: 'HSBK',
    name: 'Halyk Bank',
    category: 'Топовые акции США',
    price: '18.25',
    change: '+0.35',
    changePercent: '+1.95%',
    isPositive: true
  },
  {
    symbol: 'KAP',
    name: 'Kazatomprom',
    category: 'Топовые акции США',
    price: '28.60',
    change: '-0.45',
    changePercent: '-1.55%',
    isPositive: false
  },

  // Основные индексы (TVC)
  {
    symbol: 'SPX500',
    name: 'S&P 500',
    category: 'Основные индексы', 
    price: '5,751.20',
    change: '+18.45',
    changePercent: '+0.32%',
    isPositive: true
  },
  {
    symbol: 'NASDAQ',
    name: 'NASDAQ 100',
    category: 'Основные индексы',
    price: '18,137.85',
    change: '+75.20',
    changePercent: '+0.42%',
    isPositive: true
  },
  {
    symbol: 'DJI',
    name: 'Dow Jones',
    category: 'Основные индексы',
    price: '42,052.19',
    change: '-85.43',
    changePercent: '-0.20%',
    isPositive: false
  },
  {
    symbol: 'RUSSELL2000',
    name: 'Russell 2000',
    category: 'Основные индексы',
    price: '2,185.75',
    change: '+12.85',
    changePercent: '+0.59%',
    isPositive: true
  },

  // Европейские индексы
  {
    symbol: 'DAX',
    name: 'DAX 40 (Германия)',
    category: 'Европейские индексы',
    price: '19,245.30',
    change: '+125.85',
    changePercent: '+0.66%',
    isPositive: true
  },
  {
    symbol: 'FTSE',
    name: 'FTSE 100 (Великобритания)',
    category: 'Европейские индексы',
    price: '8,285.45',
    change: '+45.20',
    changePercent: '+0.55%',
    isPositive: true
  },
  {
    symbol: 'CAC40',
    name: 'CAC 40 (Франция)',
    category: 'Европейские индексы',
    price: '7,485.60',
    change: '+32.15',
    changePercent: '+0.43%',
    isPositive: true
  }
];

const AssetSelector = ({ selectedAsset, onAssetChange, currentPrice, assetPrices }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { tt } = useLanguage();
  const [category, setCategory] = useState('Все');
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  const categories = ['Все', 'Валютные пары', 'Криптовалюты', 'Акции', 'Товары', 'Индексы'];
  
  // Memoize filtered assets for performance optimization
  const filteredAssets = useMemo(() => {
    return category === 'Все' 
      ? ASSETS 
      : ASSETS.filter(asset => {
          // Сопоставляем категории с реальными названиями в ASSETS
          if (category === 'Валютные пары') {
            return asset.category === 'Основные валютные пары' || asset.category === 'Минорные валютные пары';
          }
          if (category === 'Криптовалюты') {
            return asset.category === 'Криптовалюты';
          }
          if (category === 'Акции') {
            return asset.category === 'Топовые акции США';
          }
          if (category === 'Товары') {
            return asset.category === 'Драгметаллы и товары';
          }
          if (category === 'Индексы') {
            return asset.category === 'Основные индексы' || asset.category === 'Европейские индексы';
          }
          return asset.category === category;
        });
  }, [category]);

  const currentAsset = ASSETS.find(asset => asset.symbol === selectedAsset);

  // Calculate dropdown position when opening
  const handleToggle = () => {
    if (!isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY + 8, // 8px margin
        left: rect.left + window.scrollX,
        width: rect.width
      });
    }
    setIsOpen(!isOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && buttonRef.current && dropdownRef.current) {
        // Check if click is not inside button or dropdown
        if (!buttonRef.current.contains(event.target) && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  return (
    <div className="relative" style={{zIndex: 9999999}}>
      {/* Current Asset Display */}
      <button
        ref={buttonRef}
        onClick={handleToggle}
        className="w-full bg-gray-800 hover:bg-gray-700 rounded-lg p-3 sm:p-4 transition-colors"
      >
        <div className="flex items-center justify-between">
          <div className="text-left flex-1 min-w-0">
            <div className="text-white font-semibold text-base sm:text-lg truncate">{selectedAsset}</div>
            <div className="text-gray-300 text-xs sm:text-sm truncate">{currentAsset?.name}</div>
            {/* Цена удалена: TradingView бесплатный виджет не предоставляет доступ к данным о ценах */}
          </div>
          <div className="text-right flex items-center space-x-1 sm:space-x-2">
            <div className={`flex items-center space-x-1 ${
              currentAsset?.isPositive ? 'text-green-400' : 'text-red-400'
            }`}>
              {currentAsset?.isPositive ? (
                <TrendingUp className="w-3 h-3 sm:w-4 sm:h-4" />
              ) : (
                <TrendingDown className="w-3 h-3 sm:w-4 sm:h-4" />
              )}
              <span className="text-xs sm:text-sm">{currentAsset?.changePercent}</span>
            </div>
            <ChevronDown className={`w-4 h-4 sm:w-5 sm:h-5 text-gray-400 transition-transform ${
              isOpen ? 'rotate-180' : ''
            }`} />
          </div>
        </div>
      </button>

      {/* Dropdown Portal */}
      {isOpen && ReactDOM.createPortal(
        <>
          <div
            className="fixed inset-0"
            style={{zIndex: 9998, background: 'rgba(0,0,0,0.1)'}}
            onClick={() => setIsOpen(false)}
          />
          <div 
            ref={dropdownRef}
            className="fixed bg-gray-800 rounded-lg border border-gray-700 shadow-xl max-h-96 overflow-auto" 
            style={{
              top: dropdownPosition.top + 'px',
              left: dropdownPosition.left + 'px',
              width: Math.max(dropdownPosition.width, window.innerWidth < 640 ? 300 : 420) + 'px',
              zIndex: 9999,
              minWidth: window.innerWidth < 640 ? '300px' : '420px',
              maxWidth: window.innerWidth < 640 ? '90vw' : 'none'
            }}
          >
            {/* Category Tabs - Mobile responsive */}
            <div className="flex bg-gray-700 p-1 m-2 rounded-md min-w-max overflow-x-auto">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setCategory(cat)}
                  className={`flex-shrink-0 px-2 sm:px-3 py-1 text-xs rounded transition-colors whitespace-nowrap ${
                    category === cat
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-300 hover:text-white'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>

            {/* Asset List */}
            <div className="max-h-72 overflow-y-auto">
              {filteredAssets.map((asset) => (
                <button
                  key={asset.symbol}
                  onClick={() => {
                    onAssetChange(asset.symbol);
                    setIsOpen(false);
                  }}
                  className={`w-full px-3 sm:px-4 py-2 sm:py-3 text-left hover:bg-gray-700 transition-colors border-l-2 ${
                    selectedAsset === asset.symbol
                      ? 'border-blue-400 bg-gray-700'
                      : 'border-transparent'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex-1 min-w-0">
                      <div className="text-white font-medium text-sm sm:text-base truncate">{asset.symbol}</div>
                      <div className="text-gray-400 text-xs sm:text-sm truncate">{asset.name}</div>
                    </div>
                    <div className="text-right flex-shrink-0 ml-2">
                      <div className={`text-xs sm:text-sm ${
                        asset.isPositive ? 'text-green-400' : 'text-red-400'
                      }`}>
                        {asset.change}
                      </div>
                      <div className={`text-xs ${
                        asset.isPositive ? 'text-green-400' : 'text-red-400'
                      }`}>
                        {asset.changePercent}
                      </div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </>,
        document.body
      )}
    </div>
  );
};

// Wrap with React.memo for performance optimization
export default React.memo(AssetSelector);